import PipelinesCard from './PipelineCard';
import PipelineStatus from './PipelineStatus';

const PipelinesCards = ({ stats, period, pipelines, togglePipeline }) => {
  const pipelineElements = [];

  for (let i = 0; i < pipelines.length; i++) {
    const pipeline = pipelines[i];
    if (pipeline.type === 'simple') {
      continue;
    }
    let status = <PipelineStatus i={i} pipeline={pipeline} togglepipeline={togglePipeline} />;

    pipelineElements.push(
      <PipelinesCard key={pipeline.id} pipeline={pipeline} status={status} stats={stats} period={period} />
    );
  }
  return pipelineElements;
};

export default PipelinesCards;
